import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { useUser } from "../../context/UserContext";
import { Api } from "../../services/api";

export default function SponsorsList() {
  const { user } = useUser();
  const api = useMemo(() => new Api(), []);
  const [sponsors, setSponsors] = useState(null);

  useEffect(() => {
    const getData = async () => {
      const response = await api.getWithAuth(
        "/api/sponsors?where[isVisible][equals]=true&sort=category.rank",
        user,
      );
      const json = await response.json();
      setSponsors(json);
    };
    getData();
  }, [user, api]);

  const groupedSponsors = useMemo(() => {
    if (!sponsors) return [];
    const grouped = sponsors.docs.reduce((acc, sponsor) => {
      const category = sponsor.category.title;
      if (!acc[category]) {
        acc[category] = {
          displayLabel: sponsor.category.displayLabel,
          rank: sponsor.category.rank,
          sponsors: [],
        };
      }
      acc[category].sponsors.push(sponsor);
      return acc;
    }, {});
    return Object.entries(grouped).sort((a, b) => a[1].rank - b[1].rank);
  }, [sponsors]);

  return (
    sponsors && (
      <div className="col-span-full px-4 py-8">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl font-bold mb-8 text-center">Partners</h2>
          {groupedSponsors.map(([category, data]) => (
            <div key={category} className="mb-8">
              <div className="flex flex-wrap justify-center gap-6">
                {data.sponsors.map((sponsor) => (
                  <Link
                    key={sponsor.id}
                    to={`/sponsor/${sponsor.id}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="border rounded-lg p-4 hover:shadow-lg transition-shadow flex flex-col items-center justify-center bg-white min-h-[150px] w-48"
                  >
                    <img
                      src={sponsor.logo.url}
                      alt={sponsor.name}
                      className="max-h-20 object-contain mb-2"
                    />
                    <p className="text-center text-sm font-semibold">
                      {sponsor.name}
                    </p>
                  </Link>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    )
  );
}
